module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/right-picture-8852bed2f735604f18fe11b25481169e.png";